import {
  LayoutDashboard, Map, Car, Users, Route, Bell, Hexagon, Wrench,
  BarChart3, Building2, UsersRound, Plug, Settings,
} from "lucide-react";

export const NAV_ITEMS = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { to: "/map", label: "Live Map", icon: Map },
  { to: "/vehicles", label: "Vehicles", icon: Car },
  { to: "/drivers", label: "Drivers", icon: Users },
  { to: "/trips", label: "Trips", icon: Route },
  // `badge` is computed live from alertService (see useNewAlertsCount),
  // not set here — it used to be a hardcoded placeholder.
  { to: "/alerts", label: "Alerts", icon: Bell },
  { to: "/maintenance", label: "Maintenance", icon: Wrench },
  { to: "/geofences", label: "Geofences", icon: Hexagon },
  { to: "/reports", label: "Reports", icon: BarChart3 },
  { to: "/facilities", label: "Facilities", icon: Building2 },
  { to: "/team", label: "Team", icon: UsersRound },
  { to: "/integrations", label: "Integrations", icon: Plug },
  { to: "/settings", label: "Settings", icon: Settings },
];

export const MOBILE_NAV = [
  { to: "/dashboard", label: "Home", icon: LayoutDashboard },
  { to: "/map", label: "Map", icon: Map },
  { to: "/vehicles", label: "Vehicles", icon: Car },
  // `badge` is computed live from alertService (see useNewAlertsCount),
  // not set here — it used to be a hardcoded placeholder.
  { to: "/alerts", label: "Alerts", icon: Bell },
];
